/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DirectoryRoleSetupHiddenAttributeKey = {
  /**
   * Directory attribute key with too many distinct values to offer in bulk setup.
   */
  key: string;
  /**
   * Number of distinct values the key has on live directory profiles.
   */
  valueCount: number;
};

/** @internal */
export const DirectoryRoleSetupHiddenAttributeKey$inboundSchema: z.ZodMiniType<
  DirectoryRoleSetupHiddenAttributeKey,
  unknown
> = z.pipe(
  z.object({
    key: z.string(),
    value_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "value_count": "valueCount",
    });
  }),
);

export function directoryRoleSetupHiddenAttributeKeyFromJSON(
  jsonString: string,
): SafeParseResult<DirectoryRoleSetupHiddenAttributeKey, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      DirectoryRoleSetupHiddenAttributeKey$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DirectoryRoleSetupHiddenAttributeKey' from JSON`,
  );
}
